import React from 'react';
import { Flex } from 'glints-aries/es';
import {
  ButtonGroup,
  OutlineButton,
  PrimaryButton,
  Typography,
} from 'glints-aries/es/@next';
import { Neutral } from 'glints-aries/es/@next/utilities/colors';
import { space24 } from 'glints-aries/es/@next/utilities/spacing';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';

import useIsSignUpLandingVariantEnabled from '../../../common/hooks/useIsSignUpLandingVariantEnabled';
import useOpenChatSupport from '../../../common/hooks/useOpenChatSupport';
import { useAppDispatch } from '../../../store';
import AppLanguageSwitcher from '../../AppLanguage/AppLanguageSwitcher';
import { hireLandingPageMessages } from '../../Landing/HireLandingPage/HireLandingPageMessages';
import { toggleSidebar } from '../Actions';
import { PrimaryHireLandingPageButton } from './HireLandingPageMenuItemContent.sc';

function SidebarContent() {
  const dispatch = useAppDispatch();
  const closeSidebar = () => dispatch(toggleSidebar());

  const openChatSupport = useOpenChatSupport();

  const handleContactUsClick = () => {
    closeSidebar();
    openChatSupport();
  };

  return (
    <Flex flexDirection="column" gap={space24}>
      <div onClick={handleContactUsClick} style={{ cursor: 'pointer' }}>
        <Typography
          variant="subtitle1"
          style={{
            textTransform: 'uppercase',
            color: Neutral.B18,
          }}
        >
          <FormattedMessage {...hireLandingPageMessages.contactUs} />
        </Typography>
      </div>
      <AppLanguageSwitcher hideDivider={true} />
    </Flex>
  );
}

function NavbarContent() {
  const history = useHistory();
  const isSignUpLandingVariantEnabled = useIsSignUpLandingVariantEnabled();

  const handlePostJobClick = () => {
    const signupPath = isSignUpLandingVariantEnabled ? '/' : '/signup';
    history.push(signupPath);
  };

  const openChatSupport = useOpenChatSupport();

  const handleContactUsClick = () => {
    openChatSupport();
  };

  return (
    <ButtonGroup
      style={{
        gap: 12,
        alignItems: 'center',
      }}
    >
      <PrimaryHireLandingPageButton onClick={handlePostJobClick}>
        <Typography
          variant="button"
          style={{
            textTransform: 'none',
          }}
        >
          <FormattedMessage {...hireLandingPageMessages.postFreeJobNow} />
        </Typography>
      </PrimaryHireLandingPageButton>
      <OutlineButton onClick={handleContactUsClick}>
        <Typography
          variant="button"
          style={{
            textTransform: 'none',
          }}
        >
          <FormattedMessage {...hireLandingPageMessages.contactUs} />
        </Typography>
      </OutlineButton>
      <AppLanguageSwitcher />
    </ButtonGroup>
  );
}

function MobileContent() {
  const history = useHistory();
  const isSignUpLandingVariantEnabled = useIsSignUpLandingVariantEnabled();

  const handlePostJobClick = () => {
    const signupPath = isSignUpLandingVariantEnabled ? '/' : '/signup';
    history.push(signupPath);
  };

  return (
    <>
      <PrimaryButton onClick={handlePostJobClick}>
        <Typography
          variant="button"
          style={{
            textTransform: 'none',
          }}
        >
          <FormattedMessage {...hireLandingPageMessages.postFreeJobNow} />
        </Typography>
      </PrimaryButton>
    </>
  );
}

export default Object.assign(
  {},
  {
    NavbarContent,
    SidebarContent,
    MobileContent,
  }
);
